export const fragenAutoMitFinanzierungVerkaufen = [
  {
    question: "Kann ich ein finanziertes Auto ohne Zustimmung der Bank verkaufen?",
    answer: (
      <>
        <p>
          Nein. Die Bank verlangt eine Begleichung oder Übertragung der Restschuld,
          bevor du verkaufen darfst.
        </p>
      </>
    ),
  },
  {
    question: "Kann der Käufer den Kredit übernehmen?",
    answer: (
      <>
        <p>
          Ja, wenn die Bank zustimmt und der Käufer kreditwürdig ist. Der Vertrag
          wird auf ihn umgeschrieben.
        </p>
      </>
    ),
  },
  {
    question: "Wer kümmert sich um die Ablöse bei Autoeinfachlos?",
    answer: (
      <>
        <p>
          Unsere Händler regeln die Ablöse direkt mit deiner Bank. Du erhältst
          danach den Restbetrag.
        </p>
      </>
    ),
  },
  {
    question: "Ist der Verkauf an einen Händler günstiger?",
    answer: (
      <>
        <p>
          Händler kalkulieren eine Marge, daher ist der Erlös etwas niedriger.
          Dafür hast du keinen Aufwand und bekommst dein Geld sofort.
        </p>
      </>
    ),
  },
];

